import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import * as moment from "moment";
import { NotificationAlertContext } from "contexts/notificationAlertContext";
import CustomReactDatetime from "components/Custom/CustomReactDatetime.js";
import { getConnectorDetail } from "graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

// react-bootstrap components
import {
  Card,
  Table,
  Container,
  Row,
  Col,
  Spinner,
  Button,
} from "react-bootstrap";

function ChannelLegacy() {
  // Hooks
  const notify = useContext(NotificationAlertContext);
  const history = useHistory();

  const { clientId, clientEnvironmentId, channelId } = useParams();

  const [startDate, setStartDate] = useState(moment().startOf('day'));
  const [endDate, setEndDate] = useState(moment().endOf('day'));
  const [connectorData, setConnectorData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  // const [errorMessage, setErrorMessage] = useState(null);

  const fetchConnector = async (query) => {
    try {
      setShowLoader(true);
      const response = await API.graphql(
        graphqlOperation(getConnectorDetail, query)
      );
      if (response.data?.getConnectorDetail?.success) {
        const data = _.get(response, "data.getConnectorDetail.body");
        setConnectorData(data);
      } else {
        console.error(response.data?.getConnectorDetail?.message);
      }
      return response.data?.getConnectorDetail?.success;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const isSuccess = await fetchConnector({
        clientId,
        channelId,
        clientEnvironmentId,
        startDate,
        endDate,
      });
      if (!isSuccess) {
        notify("danger");
        history.goBack();
      }
    }
    fetchData();
  }, []);

  if (!connectorData) {
    return <Spinner animation="grow" />;
  }

  if (showLoader) return <Spinner animation="grow" />;

  // if (errorMessage) return errorMessage;

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <h2>Channel Details</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <h5>Name: {connectorData.channel_name}</h5>
            <h5 id="channelId">Id: {channelId}</h5>
            <h5>Client Id: {clientId}</h5>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Row>
                  {connectorData && (
                    <Col md="7">
                      <p className="card-category">
                        Number of connectors:{" "}
                        {connectorData.connectors
                          ? connectorData.connectors.length
                          : 0}
                      </p>
                    </Col>
                  )}
                  <Col md="2">
                    <CustomReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Start Time",
                      }}
                      timeFormat="h:mm A"
                      value={startDate}
                      onChange={setStartDate}
                    ></CustomReactDatetime>
                  </Col>
                  <Col md="2">
                    <CustomReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "End Time",
                      }}
                      timeFormat="h:mm A"
                      value={endDate}
                      onChange={setEndDate}
                    ></CustomReactDatetime>
                  </Col>
                  <Col md="1">
                    <Button
                      variant="primary"
                      onClick={async () => {
                        // Collect validation errors
                        const errors = [];

                        // Validate start date is not after end date
                        if (startDate.isAfter(endDate)) {
                          errors.push("Start date must be lesser than end date");
                        }
                        // Show all errors if any exist
                        if (errors.length > 0) {
                          errors.forEach(error => notify("danger", error));
                          return;
                        }
                        const isSuccess = await fetchConnector({
                          clientId,
                          channelId,
                          clientEnvironmentId,
                          startDate,
                          endDate,
                        });
                        if (isSuccess) notify("success");
                        else notify("danger");
                      }}
                    >
                      {" "}
                      Search
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="table-responsive p-0">
                {connectorData &&
                  (!connectorData.connectors ||
                    connectorData.connectors.length === 0) && (
                    <>
                      <h4 style={{ textAlign: "center" }}>
                        No Data Avaliable for the Date Range
                      </h4>
                    </>
                  )}

                {connectorData &&
                  connectorData.connectors &&
                  connectorData.connectors.length > 0 && (
                    <>
                      <Table className="table-hover table-striped w-full">
                        <thead>
                          <tr>
                            <th>Connector ID</th>
                            <th>Connector Name</th>
                            <th>Filtered</th>
                            <th>Errored</th>
                            <th>Sent/Transformed</th>
                            <th>Avg Process Time (sec)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {connectorData.connectors.map((connector) => {
                            return (
                              <tr>
                                <td>{connector.connector_id}</td>
                                <td>{connector.connector_name}</td>
                                <td>{connector.filtered_total}</td>
                                <td>{connector.error_total}</td>
                                <td>{connector.sent_total}</td>
                                <td>
                                  {Math.round(
                                    10000 * connector.avg_process_time
                                  ) / 10000}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </>
                  )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ChannelLegacy;
